/* Shoevendor: de gekozen maat in beeld.

   Op mobiel is de maatrij (ul.mobile-scroll in .f8pr-variant-selection) een
   horizontale scroller. Een Shopping-advertentie wijst naar ?variant=, dus de
   bezoeker komt binnen met een maat aangevinkt, maar die staat vaak rechts
   buiten beeld: hij ziet niet welke maat er in de winkelwagen gaat. Dit script
   schuift de rij zo dat de gekozen maat in het midden staat, bij het laden en
   als het thema de rij opnieuw opbouwt. Alleen de rij schuift, de pagina niet;
   een maat die de bezoeker zelf aantikt staat al in beeld. */
(function () {
  function centreer(rij) {
    var gekozen = rij.querySelector('input:checked');
    var li = gekozen && gekozen.closest('li');
    if (!li || rij.scrollWidth <= rij.clientWidth) return;
    var r = rij.getBoundingClientRect(), m = li.getBoundingClientRect();
    rij.scrollLeft = Math.max(0, rij.scrollLeft + (m.left - r.left) - (r.width - m.width) / 2);
  }

  function alles() {
    document.querySelectorAll('.f8pr-variant-selection ul.mobile-scroll').forEach(centreer);
  }

  alles();
  window.addEventListener('load', alles);

  var gepland = false;
  new MutationObserver(function (lijst) {
    if (gepland) return;
    var raakt = lijst.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('.f8pr-variant-selection, .f8pr-variant-selection *') ||
                                    n.querySelector('.f8pr-variant-selection'));
      });
    });
    if (!raakt) return;
    gepland = true;
    requestAnimationFrame(function () { gepland = false; alles(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
